export const USER_DETAILS_QUERY_KEY = "user";
export const ALL_REPORTS_QUERY_KEY = "reports";
export const REPORT_DETAILS_QUERY_KEY = "report-details";
export const CONFIGURATION_QUERY_KEY = "configuration";
export const EQUIPMENT_QUERY_KEY = "equipment";
export const EQUIPMENT_CERTIFICATE_QUERY_KEY = "equipment-certificate";

export const EQUIPMENT_VALUES = [
  { value: "LlcbnmHu", label: "Luxometro" },
  { value: "YWRIOz4B", label: "Dosimetro" },
  { value: "iCZakfCV", label: "Calibrador Dosimetro" },
  { value: "NyVdbrxT", label: "TGBH" },
  { value: "yxTaXRqy", label: "Calibrador TGBH" },
];

// Base URL without /api/v1 - this will be added in each fetch call
export const API_BASE_URL = import.meta.env.VITE_API_URL || "";

export const PRIMARY_COLOR = "#8AAAC8";
export const HEADING_COLOR = "#434244";
export const GOOD_COLOR = "#99D161";
export const WARNING_COLOR = "#FDC75F";
export const WARNING_GOOD_COLOR = "#FDC75F";
export const WARNING_BAD_COLOR = "#F57F3B";
export const BAD_COLOR = "#E23636";

export const PAPER_SIZES = [
  { label: "A4", value: "a4" }, //default
  { label: "US Letter", value: "us-letter" },
  { label: "US Legal", value: "us-legal" },
] as const;

export const TIMEZONES = [
  { label: "Zona Centro", value: "CST" }, //default
  { label: "Zona Sureste", value: "EST" },
  { label: "Zona Pacifico", value: "MST" },
  { label: "Zona Noreste", value: "PST" },
] as const;

export const DEFAULT_OPTIONS = {
  GENERAL: {
    PAPER_SIZE: PAPER_SIZES[0].value,
    MARGIN_INCHES: "0.5",
    TIMEZONE: TIMEZONES[0].value,
    COVER_IMAGE: true,
    OUTLINE: true,
    SECTION_DIVIDERS: true,
  },
  NOISE_DOSE: {
    CRITERION_LEVEL: "90",
    EXCHANGE_RATE: "3",
    ACTION_LEVEL: "85",
    THRESHOLD_LEVEL: "80",
    DECIBEL_ROUNDING: "1",
    DOSE_ROUNDING: "1",
    UNCERTAINTY_ROUNDING: "1",
  },
  LIGHTING: {
    WALL_REFLECTION_LIMIT: "60",
    WORK_PLANE_REFLECTION_LIMIT: "50",
    DISTANCE_ROUNDING: "1",
    IC_ROUNDING: "1",
    LUX_ROUNDING: "0",
    REFLECTION_ROUNDING: "1",
  },
  TEMPERATURE: {
    BODY_TEMPERATURE_CELSIUS: "38",
    BODY_TEMPERATURE_SHIFT_CELSIUS: "1",
    TEMPERATURE_ROUNDING: "1",
    CL_HEAVY_100: "25.0",
    CL_HEAVY_75: "25.9",
    CL_HEAVY_50: "27.8",
    CL_HEAVY_25: "30.0",
    CL_LIGHT_100: "30.0",
    CL_LIGHT_75: "30.6",
    CL_LIGHT_50: "31.7",
    CL_LIGHT_25: "32.2",
    CL_MODERATE_100: "26.7",
    CL_MODERATE_75: "27.8",
    CL_MODERATE_50: "29.4",
    CL_MODERATE_25: "31.1",
  },
};

export const MXN_PER_POINT = 10;
